import {createApp} from "vue";

let $app = createApp({
    name: "cartApp",
    data() {
        return {
            settings: [],
            apiUrl: '/wp-content/plugins/site-widgets/src/Cart/api.php',
            cart: null,
            itemCount: 0
        }
    },
    computed: {
        items() {
            if(this.cart && this.cart.items){
                return this.cart.items;
            }
            return [];
        }

    },
    methods: {
        getCart() {
            let app = this;


            // First check in cookies for cart-items if we just need a count
            let decodedCookie = decodeURIComponent(document.cookie);
            let cookies = decodedCookie.split(';');
            let cartCookie = cookies.find(cookie => cookie.trim().startsWith('cart-items='));
            if(cartCookie){
                let cartItems = cartCookie.split('=')[1];
                if(cartItems){
                    try {
                        app.itemCount = parseFloat(cartItems);
                    } catch (e) {
                        console.error('Error parsing cart-items cookie:', e);
                    }
                }
            }


            return;


            // Use this later for more data in cart..

            fetch(this.apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    action: 'getCart',
                }),
            })
            .then(response => response.json())
            .then(data => {
                app.cart = data;
                app.itemCount = data.items && data.items.length ? data.items.length : 0;
            })
        },
        goToCart() {
            // Navigate to cart page
            window.location.href = window.rbShopUrl ? window.rbShopUrl('/order/checkout/') : 'https://shop.rackesbutiken.se/order/checkout/';
        }


    },
    mounted: function () {
        let app = this;
        this.getCart();

        // Listen for global event to refresh cart
        window.addEventListener('refreshCart', () => {
            app.getCart();
        });

    },
    created() {

    },
    components: {
    },
});

// Mount app to DOM
if(document.getElementById('rackes-cart')){
    $app.mount('#rackes-cart');
}